import React from "react";
import Links from "../components/Linkestan/Links";

const Linkestan = () => {
    return <Links />;
};

export default Linkestan;
